import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TicketService from 'services/ticketService';
import AdminLayout from 'layouts/AdminLayout';

export default function AdminTicketDetail() {
  const navigate = useNavigate();
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);

  useEffect(() => {
    TicketService.getDetailTicket(ticketId).then((data) => {
      setTicket(data);
    });
  }, [ticketId]);

  if (!ticket) {
    return <div>Loading...</div>;
  }

  return (
    <AdminLayout>
      <div
        className="
        flex items-center w-full 
        mx-auto mt-4 p-4 px-4
        select-none space-x-4"
      >
        <div
          className="
          flex-shrink-0 
          p-2
          cursor-pointer 
          rounded-full
          hover:bg-[#272727] hover:scale-[1.1] transition-all duration-300
          "
          onClick={() => navigate(-1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left"
          >
            <path d="M9 14 4 9l5-5" />
            <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
          </svg>
        </div>
        <div className="flex-1 text-white font-semibold text-2xl"> Orders Details</div>
      </div>

      <div className="grid place-items-center select-none m-6">
        <div
          className="
          h-[70vh] max-w-lg w-full
          mx-auto
          bg-[#1A1A1A]
          shadow-md rounded-2xl overflow-hidden 
          "
        >
          <div className="flex items-center p-4 text-gray-300 h-full">
            <div className="flex flex-col items-center w-full gap-4 h-full">
              <h1 className="mt-2 mb-2 uppercase text-lg font-bold text-indigo-300 text-wrap">Ticket #{ticket.id}</h1>
              <div className="w-full">
                <p className="font-semibold text-xl pb-4">User's Information</p>
                <div className="flex items-center bg-[#0a0a0a] rounded-2xl w-full p-6">
                  <img className="w-12 h-12 rounded-full" src={'/api/v2/image/resize?image=' + ticket.user_image + '&size=small'} />
                  <div className="ml-4">
                    <p>{ticket.user_name}</p>
                    <p>{ticket.user_email}</p>
                  </div>
                </div>
              </div>
              <div className="w-full">
                <p className="font-semibold text-xl pb-4">Ticket</p>
                <div className="flex items-center bg-[#0a0a0a] rounded-xl w-full px-6 py-3">
                  <p className="font-semibold text-xl text-wrap">{ticket.subject}</p>
                </div>
              </div>
              <div className="w-full flex-1 flex flex-col">
                <div className="flex bg-[#0a0a0a] rounded-2xl w-full p-6 flex-1">
                  <div className="w-full">
                    {(ticket.description === '' && <p>No note from user</p>) || (
                      <div className="text-wrap" dangerouslySetInnerHTML={{ __html: ticket.description }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
